import React from 'react';
// import PropTypes from 'prop-types';

// Components
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { CloseButton } from 'dabbl-react-components';

const CloseAccountPage = () => (
  <div className="CloseAccountPage">
    <Container>
      <Row>
        <Col
          xs={{size: 3, offset: 9}}
          md={{size: 1, offset: 11}}
        >
          <CloseButton linkTo="/app/campaigns" />
        </Col>
      </Row>
    </Container>
  </div>
);

export default CloseAccountPage;



// WEBPACK FOOTER //
// ./src/pages/Account/components/CloseAccountPage/CloseAccountPage.js